enum CustomFieldStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
  READONLY = "READONLY",
}

export default CustomFieldStatus;
